// メール形式チェック
function checkMail (val) {
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]*$/;
    return re.test(val);
}

// 半角英数字チェック
function checkStringType (val) {
    var re = /^[A-Za-z0-9]*$/;
    return re.test(val);
}

// アルファベットを含む半角英数チェック
function checkComplexity (val) {
    var re = /^(?=.*?[a-z])(?=.*?\d)[a-z\d]+$/i;
    return re.test(val);
}

// 半角数字チェック(ハイフンは許可)
function checkDateStringType (val) {
    if (val) {
        var re = /^[0-9\\-]+$/;
        return re.test(val);
    }
    return true;
}

// 文字数チェック(最大)
function checkStringLengthMax (val, maxCount) {
    if (val.length > maxCount) {
        return false;
    }
    return true;
}

// 文字数チェック(最小)
function checkStringLengthMin (val, maxCount) {
    if (val.length < maxCount) {
        return false;
    }
    return true;
}

// 実在日チェック
function checkCorrectDate (str) {
    if (str) {
        var delim = '-';
        var arr = str.split(delim);
        if (arr.length !== 3) return false;
        if (arr[0] < 1900) return false;
        const date = new Date(arr[0], arr[1] - 1, arr[2]);
        if (arr[0] !== String(date.getFullYear()) || arr[1] !== ('0' + (date.getMonth() + 1)).slice(-2) || arr[2] !== ('0' + date.getDate()).slice(-2)) {
            return false;
        } else {
            return true;
        }
    } else {
        return true;
    }
}

function checkCorrectTime (str) {
    if (str) {
        const num = str.replace(/:/g, '');
        if (typeof Number(num) === 'number') {
            var re = /^[0-2][0-9]:[0-5][0-9]:[0-9][0-9]/;
            return Number(num) <= 240000 && re.test(str);
        }
    } else {
        return true;
    }
}

// 時分のみチェック00:00
function checkCorrectTimeHours (str) {
    if (str) {
        const num = str.replace(/:/g, '');
        if (typeof Number(num) === 'number') {
            var re = /^[0-2][0-9]:[0-5][0-9]$/;
            return Number(num) <= 2400 && re.test(str);
        }
    } else {
        return true;
    }
}

// カンマ付料金チェック
function checkFeeType (val) {
    var num = val.replace(/,/g, '');
    var re = /^[0-9]*$/;
    return re.test(num);
}

// 日付席表現0000-00-00
function checkDateFormat (val) {
    if (val.length === 10) {
        var re = /^[1-2][0-9]{3}-[0-3][0-9]-[0-3][0-9]/;
        return re.test(val);
    } else {
        return true;
    }
}

// 日付席表現00-00
function checkDateFormatByHolidayModal (val) {
    if (val.length === 5) {
        var re = /[0-1][0-9]-[0-3][0-9]/;
        return re.test(val);
    } else {
        return true;
    }
}

function checkEmptyString (v) {
    if (v === '' || v === ' ' || v == null) {
        return false;
    } else {
        return true;
    }
}

// 半角数字のみチェック
function checkHalfWidthDigit (val) {
    var re = /[0-9]/;
    return re.test(val);
}

// 郵便番号チェック
function checkZipCode (val) {
    var re = /^[0-9]{7}/;
    return re.test(val);
}

// 電話番号チェック
function checkTel (val) {
    var re = /^\d*$/;
    return re.test(val);
}

// 携帯番号チェック
function checkmobilenumber (val) {
    var re = /^0[7-9]0?[1-9]\d{3}?\d{4}$/;
    return re.test(val);
}

// 携帯番号チェック(ハイフンなし)
function checkmobilenumberNoHyphen (val) {
    var re = /^0\d{10}$/;
    return re.test(val);
}

// カタカナチェック
function checkKana (val) {
    if (val.match(/^[ァ-ヶー０-９ー0-9]+$/)) {
        return true;
    } else {
        return false;
    }
}

function checkNum (val) {
    var re = /^\d*$/g;
    return re.test(val);
}

function checkFee (val) {
    var re = /\b\d{1,3}(,\d{3})*\b/g;
    return re.test(val);
}

function checkPlayerLeftValid (val) {
    var re = /[0-4]/g;
    return re.test(val);
}

// 半角数字だけかチェック
function checkIntType (val) {
    var re = /^([1-9]\d*|0)$/;
    return re.test(val);
}

// 全角半角カナチェック
function checkZenHanKana (val) {
    var re = /^[ァ-ヶｦ-ﾟー-]*$/;
    return re.test(val);
}

export default {
    checkMail,
    checkStringType,
    checkComplexity,
    checkDateStringType,
    checkStringLengthMax,
    checkStringLengthMin,
    checkCorrectDate,
    checkEmptyString,
    checkZipCode,
    checkTel,
    checkmobilenumber,
    checkmobilenumberNoHyphen,
    checkKana,
    checkNum,
    checkFee,
    checkDateFormat,
    checkCorrectTime,
    checkHalfWidthDigit,
    checkDateFormatByHolidayModal,
    checkPlayerLeftValid,
    checkIntType,
    checkCorrectTimeHours,
    checkFeeType,
    checkZenHanKana
};
